import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { MdDialog, MdSelectChange } from '@angular/material';
import { SendMessageComponent } from '../send-message/send-message.component';
import { UserProfile, Status } from '../../models/user-profile';
import { Annotation } from '../../models/annotation';
import { FullProfileService } from '../../services/full-profile.service';
import { ApplicantService } from '../../services/applicant.service';
import { AnnotationService } from '../../services/annotation.service';
import { JobsOffer } from '../../models/jobs-offer';
import { MessagingService } from '../../services/messaging.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { SentMessageDialogComponent } from '../sent-message-dialog/sent-message-dialog.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Message } from '../../models/message';
import { Observable } from "rxjs";
import { HighlightPipe } from '../pipes/highlight.pipe';
import { JobSelectorDialogComponent } from '../job-selector-dialog/job-selector-dialog.component';
import { AnnotationDialogComponent } from '../annotation-dialog/annotation-dialog.component';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { KanbanOfferStore } from '../state/kanban-offer.store';
import { KanbanOfferStoreList } from '../state/kanban-offer-list.store';
import { JobOffersService } from '../../services/job-offers.service';
import { Constants } from '../constants';
import { ApplyDialogComponent } from '../apply-dialog/apply-dialog.component';
import { Apply } from '../../models/apply';
import { ApplyService } from '../../services/apply.service';
import { EventDialogComponent } from '../event-dialog/event-dialog.component';
import { FormCompetenceSelectorDialogComponent } from '../form-competence-selector-dialog/form-competence-selector-dialog.component';
import { VideoDialogComponent } from '../video-dialog/video-dialog.component';

@Component({
  selector: 'app-cv',
  templateUrl: './cv.component.html',
  styleUrls: ['./cv.component.css']
})

export class CvComponent implements OnChanges, OnInit{
  @Input() userId;
  @Input() job: JobsOffer;
  @Input() isreport;
  viewAddNotes: boolean = false;
  viewNotes: boolean = false;
  viewMessages: boolean = false;
  selectedOption: string;
  @Input() nameComponent;
  errorMessage: string;
  profileSubscription;
  currentProfile: UserProfile;
  newAnnotation: string;
  role: string;
  filters:any;

  messages: Observable<Message[]>;
  msgLoading: boolean;
  msgMax: number = 3;
  msgPage: number = 1;
  msgTotal: number = 0;
  applyStatusList: any;

  annotations: Observable<Annotation[]>;
  noteLoading: boolean;
  noteMax: number = 1;
  notePage: number = 1;
  noteTotal: number = 0;

  applies: Observable<Apply[]>;
  appliesMax: number = 1;
  appliesPage: number = 1;
  appliesTotal: number = 0;

  loading: boolean = false;
  cvError: boolean = false;
  premium: string;
  query_edu = "";
  query_skill = "";
  query_exp = "";

  @Output() favoriteChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() statusChanged: EventEmitter<Status> = new EventEmitter<Status>();

  public STATUS = Constants;

  public step: number;

  constructor(public dialog: MdDialog,
              public profile: FullProfileService,
              public annotation: AnnotationService,
              public applyService: ApplyService,
              public applicant: ApplicantService,
              public message: MessagingService,
              private jobService: JobOffersService,
              private applyStatusService: ApplyStatusService,
              @Inject(MD_DIALOG_DATA) public data: any,
              // @Inject("KanbanStoreReq") private KanbanStoreReq: KanbanOfferStore,
              // @Inject("KanbanStoreNotReq") private KanbanStoreNotReq: KanbanOfferStore,
              // @Inject("KanbanStorePreSel") private KanbanStorePreSel: KanbanOfferStore,
              // @Inject("KanbanStoreReject") private KanbanStoreReject: KanbanOfferStore,
              // @Inject("KanbanStoreHired") private KanbanStoreHired: KanbanOfferStore,
              @Inject(KanbanOfferStoreList) public kanbanOfferStoreList,
              ) {
  }

  ngOnInit () {
    if (localStorage.getItem('role')) {
      this.role = localStorage.getItem('role');
    } else {
      this.role = '';
    }
    this.step = 0;
    if (this.data.filters){
      this.filters = this.data.filters;
      this.filters.query_edu = this.data.filters.query_edu;
      this.filters.query_skill = this.data.filters.query_skill;
      this.filters.query_exp = this.data.filters.query_exp;
    }else{
      this.query_edu = "";
      this.query_skill = "";
      this.query_exp = "";
    }


    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }
    console.log(this.job);
    console.log(this.userId);
    if (this.userId != undefined && this.job.id != undefined) {

      this.fetchProfile(this.job.id, this.userId);
      this.fetchAnnotations(1);
      this.fetchMessages(1);
      this.fetchApplies(1);
      // this.jobService.publish(this.job);
    }
    this.applyStatusService.getApplyStatus().subscribe(
        data => {
          let applyStatusList = data;
          let statusCustom =[];
          statusCustom.push({id: this.STATUS.STATUS_PRESELECTED, name: 'Preseleccionado' });
          applyStatusList.forEach(element => {
              statusCustom.push({id: element.id, name: element.name });
          });
          statusCustom.push({id: this.STATUS.STATUS_SELECTED, name: 'Seleccionado' });
          statusCustom.push({id: this.STATUS.STATUS_REJECTED, name: 'Rechazado' });
          //statusCustom = statusStaticFirst.concat(statusCustom);
          //statusCustom = statusCustom.concat(statusStaticLast);
          this.applyStatusList = statusCustom;
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['userId'] && (changes['userId'].previousValue !== changes['userId'].currentValue)) {
      this.fetchProfile(this.job.id, this.userId);
      this.fetchAnnotations(1);
      this.fetchMessages(1);
      this.fetchApplies(1);
    }
  }

  goToHelpEvent(){
    this.dialog.open(MessageBoxDialog, {data: {message: 'Crea eventos en tu proceso de selección e invita a los candidatos, estos recibirán un sms, un correo y una llamada automatizada que los notificará del evento y podrán aceptar o rechazar el mismo. (Este proceso puede tardar unos minutos)', information: true, showIcon: true}});
  }

  goToHelpCompetence(){
    this.dialog.open(MessageBoxDialog, {data: {message: 'Invita a los candidatos para que puedan completar un formulario de competencias (Este proceso puede tardar unos minutos)', information: true, showIcon: true}});
  }

  openVideo () {
    console.log(this.currentProfile.video);
    let dialogRef = this.dialog.open(VideoDialogComponent, {data: {
      id: this.currentProfile.video
    }});
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
      this.fetchMessages(1);
    });
  }

  putApplicantStatus (value:MdSelectChange) {
    this.applicant.putApplicantStatus(this.job.id, this.userId, this.currentProfile.status.id).subscribe(
      data => {
        let id = this.currentProfile.status.id;
        this.statusChanged.emit({id: this.currentProfile.status.id, name: this.currentProfile.status.id});
        this.jobService.getOffersById(this.job.id).subscribe(
          data => {
            this.jobService.publish(data);
          },
          error => {
            this.errorMessage = <any>error;
          }
        );
        this.kanbanOfferStoreList.refresh();
        //  this.kanbanOfferStoreList.refresh();
        // switch(id){
        //   case "275":{
        //     this.KanbanStoreReq.refresh();
        //     break;
        //   }
        //   case "0":{
        //     this.KanbanStorePreSel.refresh();
        //     break;
        //   }
        //   case "-1":{
        //     this.KanbanStoreReject.refresh();
        //     break;
        //   }
        //   case "300":{
        //     this.KanbanStoreHired.refresh();
        //     break;
        //   }
        //   default: {

        //   }
        // }
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  fetchProfile(jobId, userId) {
    this.loading = true;
    this.profileSubscription = this.profile.getProfile(userId, jobId)
      .subscribe(
        profile => this.processProfile(profile),
        error => {
          this.errorMessage = <any>error;
          this.cvError = true;
          this.loading = false;
          this.currentProfile = null;
          this.jobService.publish(this.job);
        }
      );
  }

  requirements() {
    let reqs = [];
    if (this.currentProfile.jobrequirements == undefined){
      return [];
    }else{
      if(this.currentProfile.jobrequirements[1]){
        reqs = this.currentProfile.jobrequirements[1];
      }
      return this.currentProfile.jobrequirements && reqs || [];
    }

  }

  desirableRequirements() {
    let reqs = [];
    if (this.currentProfile.jobrequirements == undefined){
      return [];
    }else{
      if(this.currentProfile.jobrequirements[0]){
        reqs = this.currentProfile.jobrequirements[0];
      }
      return this.currentProfile.jobrequirements && reqs || [];
    }

  }

  totalRequirements() {
    let reqs = 0;
    if (this.currentProfile.jobrequirements == undefined){
      return 0;
    }else{
      if(this.currentProfile.jobrequirements[1]){
        reqs = this.currentProfile.jobrequirements[1].length;
      }
      return this.currentProfile.jobrequirements && reqs || 0;
    }

  }

  totalDesirableRequirements() {
    let reqs = 0;
    if (this.currentProfile.jobrequirements == undefined){
      return 0;
    }else{
      if(this.currentProfile.jobrequirements[0]){
        reqs = this.currentProfile.jobrequirements[0].length;
      }
      return this.currentProfile.jobrequirements && reqs || 0;
    }

  }

  passedRequirements() {
    let count = 0;
    if (this.currentProfile.jobrequirements == undefined){
      return 0;
    }else{
      if (this.currentProfile.jobrequirements[1]) {
        let reqs = this.currentProfile.jobrequirements[1];
        if (reqs){
          for (let i = 0; i < reqs.length; ++i) {
            if (reqs[i].status) {
              count++;
            }
          }
        }
      }
      return count;
    }

  }

  passedDesirableRequirements() {
    let count = 0;
    if (this.currentProfile.jobrequirements == undefined){
      return 0;
    }else{
      if (this.currentProfile.jobrequirements[0]) {
        let reqs = this.currentProfile.jobrequirements[0];
        if(reqs){
          for (let i = 0; i < reqs.length; ++i) {
            if (reqs[i].status) {
              count++;
            }
          }
        }
      }

      return count;
    }

  }

  percentageRequirements() {
    return Math.floor(this.passedRequirements() / this.totalRequirements() * 100);
  }

  percentageDesirableRequirements(): number {
    return Math.floor(this.passedDesirableRequirements() / this.totalDesirableRequirements() * 100);
  }

  asCurrentDate(strdate): string {
    return (strdate === null || strdate === '0000-00-00') ? 'Actualmente' : strdate;
  }

  fetchAnnotations(page) {
    this.noteTotal = 0;
    this.noteLoading = true;
    this.annotations = this.annotation.getAnnotation(this.userId, undefined, page, this.noteMax)
      .do(res => {
        this.noteTotal = res.pagination.total;
        this.notePage = page;
        this.noteLoading = false;
      })
      .map(res => res.annotations);
  }

  fetchApplies(page) {
    this.appliesTotal = 0;
    this.applies = this.applyService.getApply(this.userId, page, this.noteMax)
      .do(res => {
        this.appliesTotal = res.pagination.total;
        this.appliesPage = page;
      })
      .map(res => res.applies);
  }

  fetchMessages(page) {
    this.msgTotal = 0;
    this.msgLoading = true;
    this.messages = this.message.getMessage(this.userId, undefined, page, this.msgMax)
      .do(res => {
        this.msgTotal = res.pagination.total;
        this.msgPage = page;
        this.msgLoading = false;
      })
      .map(res => res.messages);
  }

  addAnnotation() {
    this.annotation.postAnnotation(this.job.id, this.userId, this.newAnnotation).subscribe(
      data => {
        this.newAnnotation = '';
        this.viewAddNotes = false;
        this.fetchAnnotations(1);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  markFavorite () {
    this.applicant.putApplicantFavorite(this.job.id, this.userId, !this.currentProfile.favorite).subscribe(
      data => {
        this.currentProfile.favorite = !this.currentProfile.favorite;
        this.favoriteChanged.emit(this.currentProfile.favorite);
        this.jobService.publish(this.job);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  downloadPDF(){
    this.applicant.getApplicantCV(this.userId).subscribe(
      data => {

        const fileURL = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.download = this.currentProfile.firstname + this.currentProfile.lastname + '.pdf';
        link.target = '_blank';
        link.href = fileURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  profileCompletionRequest() {
    this.message.sendprofileCompletionRequest(this.userId, this.job.id)
    .subscribe(
      data =>this.dialog.open(MessageBoxDialog, {data: {message: "Solicitud Enviada", success:true, showIcon:true}}),
      error => {this.dialog.open(MessageBoxDialog, {data: {message: "Solicitud No Enviada: "+error, alert:true, showIcon:true}})}
    );
  }

  sendDocListRequest() {
    this.applicant.putApplicantRequestDocList(this.userId, this.job.id)
    .subscribe(
      data => {
      this.dialog.open(MessageBoxDialog, {data: {message: "Solicitud Enviada", success:true, showIcon:true}});
      },
      error => {
        this.dialog.open(MessageBoxDialog, {data: {message: "Solicitud No Enviada: "+error, alert:true, showIcon:true}})
      }

    );
  }

  processProfile(profile) {
    this.currentProfile = profile;
    this.jobService.getOffersById(this.job.id).subscribe(
      data => {
        this.job = data;
        //this.jobService.publish(data);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
    this.loading = false;
    this.cvError = false;
  }

  changeView(view) {
    if (view == 'viewAddNotes') {
      this.viewAddNotes = !this.viewAddNotes;
      this.viewNotes = false;
      this.viewMessages = false;
    } else if (view == 'viewMessages') {
      if(this.msgTotal > 0)
        this.viewMessages = !this.viewMessages;
      this.viewNotes = false;
      this.viewAddNotes = false;
    } else {
      if(this.noteTotal > 0)
        this.viewNotes = !this.viewNotes;
      this.viewAddNotes = false;
      this.viewMessages = false;
    }
  }

  openDialogMessage(user) {
    let dialogRef = this.dialog.open(SendMessageComponent, {data: {
      nameComponent: 'offer', userId: this.userId, job: this.job, useFilter: false
    }});
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
      this.fetchMessages(1);
    });
  }

  goToMap () {
    let lato = this.currentProfile.location.lat;
    let lngo = this.currentProfile.location.lng;
    let latf;
    let lngf;
    let urlMap;
    if (this.currentProfile.job.venue) {
      latf = this.currentProfile.job.venue.lat;
      lngf = this.currentProfile.job.venue.lng;
      urlMap = 'https://maps.google.com?saddr='+lato+','+lngo+'&&daddr='+latf+','+lngf;
    } else {
      urlMap = 'https://maps.google.com?q='+lato+','+lngo;
    }
    window.open(urlMap, '_blank');
  }

  onInvite() {
    this.openDialogJobSelectorDialog();
  }


  onInviteFormCompetence() {
    this.openDialogFormCompetenceDialog();
  }

  openDialogJobSelectorDialog() {
    let dialogRef = this.dialog.open(JobSelectorDialogComponent);
    dialogRef.componentInstance.createInvite=true;
    dialogRef.componentInstance.UserID=this.userId;
    dialogRef.componentInstance.JobName=this.job.title +" - "+ this.job.venue.name;
    dialogRef.componentInstance.JobID=this.job.id;
    dialogRef.componentInstance.nameComponent='Invitación';
    dialogRef.componentInstance.hv='0';

    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
        // this.dialog.open(MessageBoxDialog, {data: {message: 'Invitación Enviada', success: true, showIcon:true}});
      }
      this.jobService.publish(this.job);
    });
  }

  openDialogFormCompetenceDialog() {
    let dialogRef = this.dialog.open(FormCompetenceSelectorDialogComponent);
    dialogRef.componentInstance.UserID=this.userId;
    dialogRef.componentInstance.JobName=this.job.title +" - "+ this.job.venue.name;
    dialogRef.componentInstance.JobID=this.job.id;
    dialogRef.componentInstance.nameComponent='Invitación a Formulario de Competencias';

    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
        // this.dialog.open(MessageBoxDialog, {data: {message: 'Invitación Enviada', success: true, showIcon:true}});
      }
      // this.jobService.publish(this.job);
    });
  }

  openNotes() {
    let dialogRef = this.dialog.open(AnnotationDialogComponent, {data: {
      userId: this.userId,
      jobId: this.job.id,
      page: 1,
      noteMax: this.noteMax,
      noteTotal: this.noteTotal
    }});
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
      this.fetchAnnotations(1);
    });
  }

  openApply() {
    let dialogRef = this.dialog.open(ApplyDialogComponent, {data: {
      userId: this.userId,
      page: this.appliesPage,
      applyMax: this.appliesMax,
      applyTotal: this.appliesTotal
    }});
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }

  openMessages() {
    if (this.msgTotal !== 0) {
      let dialogRef = this.dialog.open(MessageDialogComponent, {data: {
        userId: this.userId,
        jobId: this.job.id,
        page: 1,
        msgMax: this.msgMax,
        msgTotal: this.msgTotal
      }});
    }
  }

  openCreateEvent() {
    let dialogRef;
    dialogRef = this.dialog.open(EventDialogComponent);
    dialogRef.componentInstance.jobId = this.job.id;
    dialogRef.componentInstance.userId = this.userId;
    dialogRef.componentInstance.create = true;
    dialogRef.afterClosed().subscribe(result => {
      this.fetchProfile(this.job.id, this.userId);
    });
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  openWhatsapp() {
    let companyname = 'DreamJobs';
    if (localStorage.getItem('company_name')) {
      companyname = localStorage.getItem('company_name');
    }

    let text = 'Hola, te escribimos desde ' + companyname + ', referente a la oferta de trabajo ' + this.job.title + '%20';
    window.open('https://api.whatsapp.com/send?phone=' + '57' + this.currentProfile.mobile + '&text=' + text, '_blank');
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/cv/cv.component.ts